import { render, staticRenderFns } from "./industryPoint.vue?vue&type=template&id=d2f68bb0&scoped=true&"
import script from "./industryPoint.vue?vue&type=script&lang=js&"
export * from "./industryPoint.vue?vue&type=script&lang=js&"
import style0 from "./industryPoint.vue?vue&type=style&index=0&id=d2f68bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f68bb0",
  null
  
)

export default component.exports